import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import mainPhotoDog from '@assets/images/home-dog.webp';



const MainPhoto = () => {
	const { t } = useTranslation('web');

	return (
		<div className='main-photo'>
			<div className='main-photo-text'>
				<p className='contact-phone-number'>{t('pages.home.cats.mainPhoto.phoneNumberLabel')} {t('shared.contactPhoneNumber')}</p>

				<p className='main-title'>{t('pages.home.dogs.mainPhoto.title')}</p>

				<Link to={NavigateRoutesEnum.order} className='app-main-button'>
					{t('shared.orderLongUpper')}
				</Link>
			</div>
			
			<div className='main-photo-image'>
				<img src={mainPhotoDog} alt='main-content-photo' />
			</div>
		</div>
	);
};

export default MainPhoto;